// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCGj3Fp4_77rUvg06ZnSLRFSJUTPxW2W7U",
  authDomain: "designbud.firebaseapp.com",
  projectId: "designbud",
  storageBucket: "designbud.appspot.com",
  messagingSenderId: "515504537727",
  appId: "1:515504537727:web:e534a9d88ac4d77b273f4a",
  measurementId: "G-YN8YQ1JWGH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
